import i18next from "i18next";
import { successAlert } from "../jsx/components/alert/defaultAlert";
import axiosInstance from "../services/AxiosInstance";
import { sendUploadFile } from "../services/AxiosService";
import { convertUrlObjectToFile } from "./ConverterUtils";
import { isFile } from "./CheckUtils";

// Responsável por adicionar ou atualizar um registro.
export const sendToApi = (path, data, onSuccess, onError, onSettled, onResponse) => {
    let call = null;

    // Aciona a api
    if (data.id !== null) {
        call = axiosInstance.patch(path + "/" + data.id, data);
    } else {
        call = axiosInstance.post(path, data);
    }

    call.then((resp) => {
        // Atualiza estado local assim que a API confirma; o callback pós-alerta fica
        // reservado para ações de navegação que devem aguardar a confirmação do usuário.
        if (onResponse) onResponse(resp);
        successAlert(i18next.t('message.operation_successfully'), () => {
            onSuccess(resp);
        });
    })
        .catch((error) => {
            onError(error)
        })
        .finally(() => {
            // A resposta da API encerra a submissão; o alerta de sucesso pode ficar aberto
            // sem manter o formulário bloqueado enquanto o usuário decide como continuar.
            if (onSettled) onSettled();
        });
}

export const sendToUploadFileApi = (path, data, id, successFunc, errorFunc) => {
    let call = sendUploadFile(path, id, data);

    call.then(() => {
        successAlert(i18next.t('message.operation_successfully'), () => {
            successFunc()
        });
    })
        .catch((error) => {
            errorFunc(error)
        });
}

// Define se o id é null ou se é um inteiro.
export const getId = (data) => {
    return data != null ? data.id : null;
}

// Converte um objeto para um Blob.
export const convertToBlob = (data) => {
    return new Blob([JSON.stringify(data)], {
        type: 'application/json'
    });
}

// Prepara o data para o upload file.
export const prepareUploadFileData = async (file, payload, destDir, entityData) => {
    // Na alteração é necessário converter o blob em um file e/ou converter URL em File.
    if (file) {
        if (!isFile(file)) {
            if (typeof file === 'string' && payload.id && entityData && entityData.uploadedFileName) {
                file = await convertUrlObjectToFile(file, entityData.uploadedFileName);
            } else if (file instanceof Blob) {
                const fileName = (entityData && entityData.uploadedFileName) ? entityData.uploadedFileName : "image.png";
                file = new File([file], fileName, { type: file.type || "image/png" });
            }
        }
    }

    return {
        file: file,
        data: convertToBlob(payload),
        destDir: destDir
    };
}

export const SearchOperation = {
    GREATER_THAN: "GREATER_THAN",
    LESS_THAN: "LESS_THAN",
    GREATER_THAN_EQUAL: "GREATER_THAN_EQUAL",
    LESS_THAN_EQUAL: "LESS_THAN_EQUAL",
    EQUAL: "EQUAL",
    MATCH: "MATCH",
    // Exige todas as palavras do texto, em qualquer ordem. Para nome, onde o MATCH comum
    // falha quando o cadastro tem nome do meio.
    MATCH_WORDS: "MATCH_WORDS",
    NOT_MATCH: "NOT_MATCH",
    MATCH_START: "MATCH_START",
    MATCH_END: "MATCH_END",
    IS_NULL: "IS_NULL",
    IS_NOT_NULL: "IS_NOT_NULL",
    NOT_EQUAL: "NOT_EQUAL",
    IN: "IN",
    NOT_IN: "NOT_IN"
}
